$(document).ready(function() {
jQuery(document).on('click', '.remove-link', function () {
  $(this).siblings(".cart-item--quantity-wrapper").find("input.cart-item-quantity").val(1);
  $(this).siblings(".cart-item--quantity-wrapper").find(".cart-item-decrease").click(); 
    return false;
  });

  // $("form.collection-ATC").submit(function(e){
  //   e.preventDefault()
  //   let form = $(this)
  //   let formData = $(this).serialize();
  //   $.ajax({
  //       type: 'POST',
  //       url: '/cart/add.js',
  //       dataType: 'json',
  //       data: formData,
  //       success: function (data) {
  //           jQuery.getJSON('/cart.js', function(cart) {
              
  //           });
  //         // This is event for sidecart
  //           document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
  //         detail: {
  //           product: data, //replace this variable with response
  //           // addToCartBtn: this.addToCart
  //         }
  //       }));
  //       },
  //       error: function (err) {
  //           document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
  //         detail: {
  //           errorMessage: error.description
  //         }
  //       }));
  //       }
  //   });
  // });
});